import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

function DynamicsLogo({ src = '/images/affiliate-logo.png', alt = 'Affiliate Logo', height = 'auto', width = 'auto', style = {} }) {
    return (
        <Box
            component="img"
            src={src}
            alt={alt}
            height={height}
            width={width}
            sx={{
                maxWidth: '100%', // Ensures that the image doesn't exceed container size
                height: height,
                width: width,
                objectFit: 'contain', // Keeps the aspect ratio intact
                ...style, // Allow for additional styling via props
            }}
        />
    );
}

DynamicsLogo.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    style: PropTypes.object,
};

export default DynamicsLogo;
